import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "flex items-center divide-x divide-gray-lp-2100 gap-x-3 h-full" }
const _hoisted_3 = { class: "flex gap-x-4 font-montserrat text-black-lp-300 text-sm w-max" }
const _hoisted_4 = { class: "flex flex-col gap-y-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-base" }, "Jam", -1)
const _hoisted_6 = {
  class: "flex flex-col py-2 gap-y-1 border border-gray-lp-2100 rounded-md h-60 overflow-y-auto",
  style: {"scrollbar-color":"#D4D5D8 #EBECF0","scrollbar-width":"thin"}
}
const _hoisted_7 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-red-lp-100 z-10 absolute top-1/2 transform -translate-y-1/2 left-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col gap-y-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "font-semibold text-base" }, "Menit"),
  /*#__PURE__*/_createVNode("div", { class: "flex flex-col py-2 gap-y-1 border border-gray-lp-2100 rounded-md h-60 overflow-y-auto" }, [
    /*#__PURE__*/_createVNode("span", { class: "text-center bg-gray-lp-1200 px-10 py-1" }, " 00 ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "flex items-center justify-between border border-gray-lp-2100 rounded-md px-3 h-9 text-gray-lp-600 w-full mt-2 text-sm",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openHours && _ctx.openHours(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Icons, {
          name: "clock-v4",
          class: "w-5"
        }),
        _createVNode("span", {
          class: ["pl-3 h-full flex items-center", { 'text-black-lp-300': _ctx.modelValue }]
        }, _toDisplayString(_ctx.modelValue || "Pilih waktu"), 3)
      ]),
      _createVNode(_component_Icons, {
        name: _ctx.iconHours,
        class: "w-4"
      }, null, 8, ["name"])
    ]),
    _createVNode(_component_OverlayPanel, {
      id: "select-hours",
      ref: "opHours",
      appendTo: "body"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(24), (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: item,
                  class: ["text-center cursor-pointer hover:bg-gray-lp-1200 px-10 py-1 relative", {
                'bg-gray-lp-1200 hours-active': _ctx.isSelectedHours(index)
              }],
                  onClick: (e) => _ctx.selectHours(e, index)
                }, [
                  (_ctx.isSelectedHours(index))
                    ? (_openBlock(), _createBlock("div", _hoisted_7))
                    : _createCommentVNode("", true),
                  _createVNode("span", null, _toDisplayString(index), 1)
                ], 10, ["onClick"]))
              }), 128))
            ])
          ]),
          _hoisted_8
        ])
      ]),
      _: 1
    }, 512)
  ]))
}